import { render, staticRenderFns } from "./five.vue?vue&type=template&id=7124cb4e&scoped=true"
import script from "./five.vue?vue&type=script&lang=js"
export * from "./five.vue?vue&type=script&lang=js"
import style0 from "./five.vue?vue&type=style&index=0&id=7124cb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.20_css-loader@6.11.0_webpack@5.101.3__lodash@4_926e3ab2bffa66a29e90045929af258e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7124cb4e",
  null
  
)

export default component.exports